import React, { ReactElement } from 'react'

import { BuyWithCashIcon, DepositIcon, TransferIcon } from '@Static/icons/FundAccountIcons'

import { MODAL_TYPES } from '@Redux/slices/modals/enums'

import { ROUTE_NAMES } from '@UI/crypto_exchange/desktop/routes/routeNames'

export interface IGetFundAccountModalData {
  title: string
  description: string
  icon: ReactElement
  link?: string
  button: IModalButton
}

export interface IModalButton {
  text: string
  modalName?: MODAL_TYPES.MARGIN_TRANSFER
  link?: string
}
export const getFundAccountModalData: IGetFundAccountModalData[] = [
  {
    title: 'Internal Transfer',
    description: 'Transfer from your internal account',
    icon: <TransferIcon />,
    button: { text: 'Transfer', modalName: MODAL_TYPES.MARGIN_TRANSFER },
  },
  {
    title: 'Buy with cash',
    description: 'If you want to buy crypto currency directly with cash, this will be the best way for you.',
    icon: <BuyWithCashIcon />,
    button: { text: 'Buy' },
  },
  {
    title: 'Send coin to Binance',
    description: 'If you already hold some crypto currency, you can choose to transfer them to Binance via blockchain.',
    icon: <DepositIcon />,
    button: { text: 'Deposit', link: `${ROUTE_NAMES.DEPOSIT}USD` },
  },
]
